import React from 'react';
import { Agent } from '../../types';

interface AgentCardProps {
  agent: Agent;
  selected?: boolean;
  onClick?: () => void;
}

const AgentCard: React.FC<AgentCardProps> = ({ agent, selected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-xl p-5 shadow-sm cursor-pointer transition-all duration-200 border-2 ${
        selected
          ? 'border-primary bg-gradient-to-br from-primary/5 to-secondary/5 transform -translate-y-1'
          : 'border-transparent hover:border-primary/30 hover:shadow-md hover:-translate-y-1'
      }`}
    >
      <div className="flex items-start gap-4 mb-4">
        <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-2xl flex-shrink-0">
          {agent.icon}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 text-lg mb-1 truncate">
            {agent.name}
          </h3>
          <p className="text-xs text-gray-500">
            {agent.requiredRoles.length > 0 ? agent.requiredRoles.join(', ') : 'All Users'}
          </p>
        </div>
      </div>
      
      <p className="text-sm text-gray-600 mb-4 line-clamp-2">
        {agent.description || 'No description available'}
      </p>
      
      <div className="flex flex-wrap gap-2">
        {agent.capabilities.slice(0, 3).map((cap, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium"
          >
            {cap}
          </span>
        ))}
        {agent.capabilities.length > 3 && (
          <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium">
            +{agent.capabilities.length - 3} more
          </span>
        )}
      </div>
    </div>
  );
};

export default AgentCard;
